<template>
    <div>
    <!-- <v-data-table
        :headers="headers"
        :items="tableDatas"
        :search="search"
        :loading="loading"
        :items-per-page="8"
        :value="value"
        loading-text="Loading... Please wait"
        show-select
        item-key="aid"
        class="data-table elevation-0"
        @input="enterSelect($event)"
        @click:row="infoClick"
    > --> 
    <v-data-table
        :headers="headers"
        :items="tableDatas"
        :search="search"
        :loading="loading"
        :items-per-page="rowsPerPage"
        :value="value"
        loading-text="Loading... Please wait"
        show-select
        item-key="aid"
        class="data-table elevation-0"
        @input="enterSelect($event)"
        @click:row="infoClick"
        hide-default-footer
    >


   
        <template v-slot:item.image="{ item }" fixed>
                <div class="image-container ma-1">
                    <v-img 
                    :src="getImage(item.image)"
                    style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                    :contain="true"
                    >
                    <div class="overlay_wrap" v-if="codecCheck(item)==='encoded'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">{{ $store.getters.t('인코딩 후 영상 재생이 가능합니다.') }}</span>
                    </v-tooltip>
                    </div>
                    <div class="overlay_wrap" v-else-if="codecCheck(item)==='extract'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">{{ $store.getters.t('메타데이터 추출 중입니다.') }}</span>
                    </v-tooltip>
                    </div>
                    <div class="overlay_wrap" v-else-if="codecCheck(item)==='waiting'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">{{ $store.getters.t('인코딩 대기 중입니다.') }}</span>
                    </v-tooltip>
                    </div>
                    <div class="overlay_wrap" v-else-if="codecCheck(item)==='abnormal'" >
                    <v-tooltip bottom  color="#FFF3F3">
                        <template v-slot:activator="{ on, attrs }">
                            
                                <div class="overlay">
                                    <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                </div>

                        </template>
                        <span style="color: #FF0505;">{{ $store.getters.t('비정상적인 파일입니다.') }} </span>
                    </v-tooltip>
                    </div>
                    </v-img>
                </div>
            </template>

            <template v-slot:item.secure="{ item }"> 
                <v-chip small v-if="item.secure" class="success_chip">ON</v-chip>
                <v-chip small v-else disabled>OFF</v-chip>
            </template>

            <template v-slot:item.name="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click.stop="goAction(item.assetId)" class="mdi mdi-folder-search-outline"></v-icon>
                        <!-- <v-icon v-bind="attrs" v-on="on" @click.stop="goAction(item.assetId)" class="mdi mdi-pencil-circle-outline"></v-icon> -->
                        <!-- <v-icon v-bind="attrs" v-on="on" @click.stop="goAction(item.assetId)" class="mdi mdi-information-slab-circle-outline"></v-icon> -->
                        <!-- <v-icon v-bind="attrs" v-on="on" @click.stop="goAction(item.assetId)" class="mdi mdi-dots-horizontal-circle-outline"></v-icon> -->
                    </template>
                    <span>{{ $store.getters.t('상세보기')}}</span>
                </v-tooltip>
                <span 
                    @click="goAction(item.assetId)" 
                    style="color: inherit; text-decoration: none; cursor: pointer !important;"
                    >
                {{ item.name }}
                </span>
            </template>
        
        <!-- <template v-slot:item.runtime="{ item }">
            <div v-for="(icon, index) in codecCheck(item.assetId)" :key="index" >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" v-if="icon" color="error">mdi-alert-circle</v-icon>{{ item.runtime }}
                    </template>
                    <span>인코딩 후 영상 재생이 가능합니다.</span>
                </v-tooltip>
            </div>
        </template> -->
        <template v-slot:item.status="{ item }">
            <!-- <Chips v-for="(chip, index) in chips(item.assetId)" :key="index" :chipText="chip.text" :ChipsColor="chip.color"/> -->
            <template v-for="(chip, index) in chips(item.assetId)">
                <!-- <template v-if="chip.text == 'processing ...' || chip.text.includes('processing ...')"> -->
                <template v-if="chip.text.includes('processing')">
                    <v-progress-circular 
                        :key="'progress-' + index"
                        :rotate="-90"
                        :size="33"
                        :width="5"
                        :value="chip.percent"
                        class="mr-1"
                        >
                        <span style="font-size: 10px;">{{ chip.percent }}%</span>
                    </v-progress-circular>
                </template>
                <template v-else>
                    <Chips :key="'chips-' + index" :chipText="chip.text" :ChipsColor="chip.color" class="mr-1"/>
                </template>
            </template>

            
           <!-- <v-progress :key="index" :value="chip.id"></v-progress> -->
          
            <!-- <template v-if="item.status && isProgress(item.status)">
                    <template v-for="(key, index) in getData(item)">
                        <v-progress-circular 
                        :key="index"
                        :rotate="180"
                        :size="40"
                        :width="6"
                        :value="80"
                        >
                        <span style="font-size: 12px;">{{ key }}%</span>
                        </v-progress-circular>
                    </template>
            </template>
                <template v-if="item.status && isEncoded(item.status)">
                    <Chips v-for="(key, index) in getData(item)" :key="index" :chipText="key + 'p'" :ChipsColor="getColor(item.status)"/>
                </template> -->
                <!-- <template v-if="item.status && isProgress(item.status)">
                    <template v-for="(key, index) in getData(item)">
                        <v-progress-circular 
                        :key="index"
                        :rotate="180"
                        :size="40"
                        :width="6"
                        :value="key.percent"
                        >
                        <span style="font-size: 12px;">{{ key.percent }}%</span>
                        </v-progress-circular>
                    </template>
                </template>
                <template v-if="item.status && isEncoded(item.status)">
                    <Chips v-for="(key, index) in getData(item)" :key="index" :chipText="key + 'p'" :ChipsColor="getColor(item.status)"/>
                </template> -->
        </template>

        <template v-slot:item.groupData="{ item }">
            <!-- <div style="width: 150px;" class="mt-1">
                <template v-if="item.groupData.length">
                    <span v-for="(group, index) in item.groupData" :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                        {{ group }}
                    </span>
                </template>
            </div> -->
                <template v-for="(group, index) in item.groupData.slice(0, 3)">
                    <span :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                        {{ group }}
                    </span>
                </template>
                <span v-if="item.groupData.length > 3" class="asset_group_more">
                    외 {{ item.groupData.length - 3 }}개
                </span>
        </template>

        <template v-slot:item.social_upload="{ item, index }">
            <div class="social-upload-btn-wrapper">
                <v-btn icon @click.stop="handleSocialUploadClick(item, index)">
                    <v-icon class="mdi mdi-cloud-upload-outline"/>
                </v-btn>
                <div v-if="!canUseSocialPublish" class="btn-lock-overlay">
                    <v-icon small color="#92400e">mdi-lock</v-icon>
                </div>
            </div>
            <!-- <SocialUploadModal :value="modalOpen" @input="modalOpen = $event" /> -->
            <AppDialogLarge
                :value="modalOpen[index]"
                @input="onDialogInput(index, $event)"
                max-width="960px"
            >
                <template v-slot:title>
                    <span class="social_title">{{ item.name }}</span>
                </template>
                <!-- <template v-slot:close>
                    <v-btn icon @click="closeDialog(index)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template> -->
                <template v-slot:content>
                    <SocialUploadContent
                        v-if="modalOpen[index]"
                        :itemName="item.name"
                        :itemTag="item.tagData"
                        :filename="item.filename"
                        :imageSrc="getImage(item.image)"
                        :runtime="item.runtime"
                        :standardVal="standardVal"
                        :asset-id="item.assetId || item.id"
                        @end-upload="handleUploadComplete(index)"
                        @close="closeDialog(index)"
                        @request-close="closeDialog(index)"
                    />
                </template>
            </AppDialogLarge>
        </template>

    </v-data-table>

    <v-dialog v-model="planUpgradeDialog" max-width="420">
        <v-card class="pa-6 text-center">
            <v-icon size="56" color="grey darken-1" class="mb-3">mdi-lock-outline</v-icon>
            <h3 class="mb-2">
                {{ $store.getters.t ? $store.getters.t('social.upload.locked.free_plan') : '무료 플랜에서는 소셜 업로드를 사용할 수 없습니다.' }}
            </h3>
            <p class="mb-6">
                {{ $store.getters.t ? $store.getters.t('social.upload.locked.upgrade_required') : 'SNS 연동 및 멀티 채널 업로드 기능은 상위 플랜에서 제공됩니다. 업그레이드 후 다시 시도해 주세요.' }}
            </p>
            <v-btn color="primary" depressed @click="planUpgradeDialog = false">
                {{ $store.getters.t ? $store.getters.t('common.action.ok') : '확인' }}
            </v-btn>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
import Chips from '@/components/ui/chips/Chips.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import AssetApi from '@/api/asset/AssetApi';
import TemplateFormVue from '../template/TemplateForm.vue';
import SocialUploadModal from '@/components/socialupload/SocialUploadModal.vue';
import SocialUploadContent from '@/components/socialupload/SocialUploadContent.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppTextField from '@/components/app/AppTextfield';
import AppSelect from '@/components/app/AppSelect.vue';
import SelectBox from '@/components/asset/SelectBox.vue';
import SocialApi from '@/api/social/SocialApi';
import IconTextButtonoutline from '@/components/ui/button/IconTextButton_outline.vue';

export default {
    components: {
        Chips,
        SocialUploadModal,
        AppDialogLarge,
        SocialUploadContent,
        TextButton,
        TextButtonBlock,
        AppTextField,
        AppSelect,
        SelectBox,
        IconTextButtonoutline,
    },
    props: {
        headers: {
        type: Array,
        required: true
        },
        items: {
        type: Array,
        required: true
        },
        loading: {
        type: Boolean,
        required: true
        },
        search: {
        type: String,
        required: true
        },
        rowsPerPage: {
        type: Number,
        required: true
        },
        enterSelect: {
        type: Function,
        required: true
        },
        value: {
        type: Array,
        required: true
        },
        rowClick: {
        type: Function,
        required: true
        },
    },
        data() {
        return {
            result: {},
            flag: null,
            progress: [],
            modalOpen: [],
            e1: 1,
            selectedCard: 'none',
            isChecked: false,
            uploadTitle: null,
            uploadStatus: 'private',
            uploadCate: '인물/블로그',
            uploadDescript: null,
            filename: null,
            btnStatus: false,
            overlayVal: false,
            planUpgradeDialog: false,
        }
    },
    mounted() {
        // console.log("테이블 확인 ", this.tableDatas)
        // this.flag = false;
        // if(this.items && this.dataLoad){
        //     this.flag = true;
        // }
        this.ensureModalStateLength();
    },
    watch: {
        items: {
            handler() {
                this.ensureModalStateLength();
            },
            immediate: true,
        },
    },
    computed: {
        ...mapState('asset', ['dataLoad']),
        ...mapGetters('objectData', ['getStandard']),
        ...mapGetters('naviList', ['permissionMap']),
        canUseSocialPublish() {
            return Boolean(this.permissionMap?.socialPublish);
        },
        chips() {
            return (id) => {
                if(this.dataLoad && this.tableDatas){
                    return this.getChipData(id);
                    // if(!this.result[id]){
                    //     this.getChipData(id);
                    // }
                    // return this.result[id];
                }
                else {
                    return null;
                }
                // if(!this.result[id]){
                //     this.getChipData(id);
                // }
                // return this.result[id];
               
            }
        },
        tableDatas(){
           if(this.dataLoad && this.items){
                return this.items;
           }
           return this.items;
        },
        standardVal(){
            return {
                privacyData: this.getStandard('privacyData'),
                youtubeCat: this.getStandard('youtubeCat'),
            }
        },
        googleLogin(){
            const googleToken = sessionStorage.getItem("google_access_token");
            if(googleToken){
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        ...mapActions('asset', ['fetchDetailId']),
        onDialogInput(index, value) {
            this.ensureModalStateLength();
            this.$set(this.modalOpen, index, value);
        },
        handleUploadComplete() {
            // Placeholder for future hooks (e.g., refresh task list)
        },
        // sizeCheck(item){
        //     if((item.size_bytes) > 256 * 1024 * 1024 * 1024){
        //         return false;
        //     } else {
        //         return true;
        //     }
        // },
        // codecCheck(item){
        //     // if(item.upload_v_codec !== 'h264' && (item.status === 'uploaded' || item.status === 'processing')){
        //     //     return true; 
        //     // } else if((item.status === 'h264' || item.status !== 'h264') && item.status.includes('encoded')){
        //     //     return false;
        //     // }
        //     if(item.upload_v_codec !== 'h264' && (item.status === 'uploaded' || item.status === 'processing')){
        //         return true; 
        //     } else if((item.upload_v_codec === 'h264' || item.upload_v_codec !== 'h264') && item.status.includes('encoded')){
        //         return false;
        //     } else if(item.upload_v_codec === 'h264' && item.status === 'uploaded'){
        //         return false; 
        //     }
        // if(this.dataLoad && this.tableDatas){
            //     // console.log(this.tableDatas.map((e) => e))
            //     const list = this.tableDatas.filter(e => e.assetId === id);
            //     const data = list.map(e => e.upload_v_codec !== 'h264');
            //     return data;
            // }
        codecCheck(item){
            if(item.upload_v_codec != 'h264' && (item.status == 'uploaded' || item.status == 'processing')){
                return 'encoded';
            } else if((item.status == 'h264' || item.status != 'h264') && item.status.includes('encoded')){
                return 'upload';
            }  else if(item.status == 'extract' || item.status.includes('extract')){
                return 'extract';
            } else if(item.status == 'abnormal' || item.status.includes('abnormal')){
                return 'abnormal';
            } else if(item.status == 'waiting' || item.status.includes('waiting')){
                return 'waiting';
            } 
        },
        getImage(src){
            if (src && src.trim() !== "") {
                return src;
            } else {
                return "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
            }
        },
        goAction(item){
            if(sessionStorage.getItem('AccessToken') == null) return;

            this.fetchDetailId(item);
            this.$router.push({name: 'asset-modify'});
        },
        infoClick(val){
            // console.log("val => ", val)
            // this.$emit('rowClick');
            this.rowClick(val);
        },
        updateType(val) {
            return val.toString().split(" ")[0];
        },
        // enterSelect(value) {
            
        //     console.log("dd => ", value)
        //     this.$emit('input', value); 
        // },
        // flattenAndCompare(arr1, arr2) {
        //     const flattenedArr2 = (arr2.map(e=>e.encoding_type)).flat();  
        //     console.log("flat => ", flattenedArr2)
        //     return arr1.filter(item1 => !flattenedArr2.includes(item1)); 
        // },
        saveInfo(id, result){
            // this.result[id] = result;
            this.$set(this.result, id, result);

            //console.log("saveInfo 확인 => ", this.result)
        },
        getChipData(id) {

            const result = [];
            // const datas = this.tableDatas.map(e => e.sortOut);
            // const data = datas.map(e => e).reduce((acc, curr) => acc.concat(curr), []);  // datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            // const datas = this.tableDatas.map(e => e.encodingInfo);
            // const data = datas.map(e => e).reduce((acc, curr) => acc.concat(curr), []);  // datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            // // const filteredData = filter.map(e => e);
            // // console.log("필터링 데이터 2=> ", filter)

            // const res = filter.map(e => {
            //     // console.log(e.status)
            //     const text = e.status.match(/^processing\s/) ? 'processing' : this.updateType(e.type);
            //     const color = e.status === 'encoded' ? 'black' : '!black';
            //     const percent = e.status.match(/^processing\s/) ? (e.percent ? e.percent : null) : null;

            //     return {
            //         text: text,
            //         color: color,
            //         percent: percent
            //     };
            // });
           

            // const data = this.tableDatas.map(e => e.encodingInfo).reduce((acc, curr) => ascc.concat(curr), []);
            const data = this.tableDatas.map(e => e.encodingInfo).flat();
            if(data){
                const filtered = data.filter(e => e.origin_asset_id === id);
                // console.log('필터링 결과:', filtered);

                // console.log('---- filtered ----');
                // console.table(filtered.map(e => ({ type: e.type, status: e.status, percent: e.percent })));

                const typeDatas = {};
                filtered.forEach(e => {
                    if (!e.type) return;

                    const type = e.type;
                    const text = e.status?.includes('processing') ? 'processing ...' : this.updateType(e.type);
                    const status = e.status;
                    const percent = status === 'processing ...' ? (e.percent || 0) : null;

                    typeDatas[type] = {
                        text: text,
                        color: status === 'encoded' ? 'black' : '!black',
                        percent: percent
                    };
                });

                for (const type in typeDatas) {
                    result.push(typeDatas[type]);
                }
            }
            
            // console.log(result)



        //     const res = filtered.map(e => {
        //         const text = e.status.startsWith('processing') ? 'processing' : this.updateType(e.type);
        //         const color = e.status === 'encoded' ? 'black' : '!black';
        //         const percent = e.status.startsWith('processing') ? (e.percent || 0) : null;
        //         // const percent = e.status.match(/^processing\s/) ? this.progress : null;

        //         return {
        //             text: text,
        //             color: color,
        //             percent: percent
        //         };
        //     });

        //     result.push(...res);

        //   //   console.log("res =====> ", result)

        // console.log('---- result ----');
        // console.log(result);



            return result;

            // const datas = this.tableDatas.map(e => e.sortOut);
            // const data = datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            // console.log("필터링 데이터 1=> ", filter)

           
            // filter.forEach(e => {
            //     let text = filter.map(e => e.type) === 'processing' ? 'processing' : this.updateType(filter.map(e => e.type));
            //     let color = filter.map(e => e.status) === 'encoded' ? 'black' : '!black'; 
                
            //     // const result = {
            //     //     text: text,
            //     //     color: color
            //     // };

            //     text.split(',').forEach(e => {
            //         this.saveInfo(id, { text: e.trim(), color });
            //     });

                // this.$set(this.result, id, {
                //     text: text,
                //     color: color,
                //     id: id 
                // });
            // });
            
            // const all = datas.flatMap(e => e.map(obj => obj.type));
            // if (filter.length > 0) {
                // filter.forEach(e => {
                //     texts.push(e.type === 'processing' ? 'processing' : this.updateType(e.type));
                //     colors.push(e.status === 'encoded' ? 'black' : e.status);
                // });

           


           
                // let text = filter.map(e => e.type) === 'processing' ? 'processing' : this.updateType(filter.map(e => e.type));
                // let color = filter.map(e => e.status) === 'encoded' ? 'black' : '!black'; 
                // let size = filter.map(e => e.size);
                // let resolution = filter.map(e => e.resolution);

                // this.saveInfo(id, {text, color, size, resolution});

                // this.$set(this.result, id, {
                //     text: text,
                //     color: color,
                //     size: sizes,
                //     resolution: resolutions,
                //     id: id 
                // });
            // }

            // this.result = res;
            // console.log("getChipData => ", this.results)
            // return this.result;
            

                // const datas = this.tableDatas.map(e => e.sortOut);
                // // const all = datas.flatMap(e => e.map(obj => obj.type));
                // // console.log("확인check => ", this.tableDatas)
                // const filter = datas.filter(e => e[0].origin_asset_id === id);
                // // console.log("확인checktempDatatempData => ", filter)
                // let text = filter.map(e => e.type) === 'processing' ? 'processing' : this.updateType(filter.map(e => e.type));
                // let color = filter.map(e => e.status) === 'encoded'? 'black' : filter.map(e => e.status)
                // res.push({
                //     text: text,
                //     color: color,
                //     size: filter ? filter.map(e => e.size) : null,
                //     resolution: filter ? filter.map(e => e.resolution) : null,
                //     id: filter ? filter.map(e => e.id) : null
                // });
                // return res;
               
                // const result = filter.map(e => {
                //     const types = e.map(e => e.type);
                //     const status = e.map(e => e.status);
                //     // // const text = types === 'processing' ? 'processing' : this.updateType(types);
                //     // const text = types.includes('processing') ? 'processing' : this.updateType(types);
                //     // // const color = status === 'encoded'? 'black' : status
                //     // const color = status.includes('encoded') ? 'black' : this.updateType(types);

                //     return { text, color };
                // });
                // console.log("결과확인 -> ", result)
                // return result;
        

            // const encodingInfo = this.items.flatMap(e => e.encodingInfo);
            // const filter = encodingInfo.filter(e => e.origin_asset_id === id);
            // this.$set(this.result, id, filter.map(e => {
            //     let text;
            //     if ('ischeck' in e) {
            //         text = e.type;
            //     } else {
            //         text = (e.status === 'processing') ? 'processing' : e.type;
            //     }
            //     const color = ('ischeck' in e) ? '!black' : ((e.status === 'encoded' || e.status === 'processing') ? 'black' : '!black');
            //     return { text, color };
            // }));

                // console.log("result => ", this.result);
        },
            

            // // 필터링된 데이터
            // const filter = encodingInfo.filter(e => e.origin_asset_id === id);
            // // console.log("filter => ", filter)

            // // 해상도, 상태 추출 (From filtered data)
            // this.result = filter.map(e => {
            //     let text;
            //     let status;
            //     if ('ischeck' in e) {
            //         text = e.type;
            //     } else {ㄹ
            //         text = (e.status === 'processing') ? 'processing' : e.type;
            //     }

            //     const color = ('ischeck' in e) ? '!black' : ((e.status === 'encoded' || e.status === 'processing') ? 'black' : '!black');

            //     return { text, color };
            // });
            generateColor1(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };
            const color = "#" + ((hashCode(group) & 0xFFFFFF) << 0).toString(16);
            return color;
        },

        generateColor(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };

            let hash = hashCode(group) + group.length * 123456 + group.charCodeAt(0) * 98765;
            let color = ((hash & 0xFFFFFF) << 0).toString(16);

            while (color.length < 6) {
                color = "0" + color;
            }

            return `#${color}`;
        },

        generateColor2(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };

            let hash = hashCode(group) + group.length * 123456;
            let color = ((hash & 0xFFFFFF) << 0).toString(16);

            while (color.length < 6) {
                color = "0" + color;
            }

            return `#${color}`;
        },
        async socialUpload(){

            this.btnStatus = true;
            this.overlayVal = true;
            // console.log(item)
            // console.log("제목 : ", this.uploadTitle);
            // console.log("태그 : ", this.uploadDescript);
            // console.log("privacy : ", this.uploadStatus);
            // console.log("category : ", this.uploadCate);
            // console.log("상태 : ", item.status);    // "encoded" & "uploaded"
            // console.log("filename : ", this.filename);
            // console.log("frame : ", item.upload_frames);

            const token = sessionStorage.getItem("google_access_token");
            const params = {
                token: token,
                // status: item.status,   
                title: this.uploadTitle,
                category: this.uploadCate,
                privacy: this.uploadStatus,
                tag: this.uploadDescript,
                filename: this.filename,
                // frame: item.upload_frames,
                // bitrate: item.upload_bitrate,
                // type: item.upload_resolution,
                // direction: item.upload_direction,
            }

            const response = await SocialApi.uploadYouTube(params);
            console.log("유튜브 업로드 res => ", response);
            if(response.status === 1){
                setTimeout(() => {
                    this.overlayVal = false;
                    this.btnStatus = false;
                }, 3000)
                this.e1 = 3;
            } 
        },
        handleSocialUploadClick(item, index){
            if (!this.canUseSocialPublish) {
                this.planUpgradeDialog = true;
                return;
            }
            this.openDialog(item, index);
        },
        openDialog(item, index){
            this.ensureModalStateLength();
            this.$set(this.modalOpen, index, true);
        },
        closeDialog(index){
            this.ensureModalStateLength();
            this.$set(this.modalOpen, index, false);
        },
        endUpload(){
            this.modalOpen = this.modalOpen.map(() => false);
        },
        ensureModalStateLength() {
            const length = Array.isArray(this.items) ? this.items.length : 0;
            if (this.modalOpen.length !== length) {
                this.modalOpen = Array(length).fill(false);
            }
        },
        onPrivacySelected(newVal){
            this.uploadStatus = newVal; 
        },
        onCateSelected(newVal){
            this.uploadCate = newVal; 
        },
        async selYouTube(){
            if(this.googleLogin){
                this.selectedCard = 'youtube';
                this.isChecked = true;
            } else {
                const response = await SocialApi.googleLogin();
            }
        },
        // resetStepper() {
        //     if (this.modalOpen) {
        //         this.e1 = 1;
        //     }s
        // },

    },
}
</script>

<style scoped>
.image-container{
    position: relative; 
    background-color: black; 
    width: 107px;
    height: 60px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    overflow: hidden;
    border-radius: 6px;
}

.upload-container{
    position: relative; 
    background-color: black; 
    width: 100%;
    height: 100%;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    overflow: hidden;
    border-radius: 6px;
}

.upload-container2{
    background-color: black; 
    width: 100%;
    height: 197px;
    overflow: hidden;
    border-radius: 6px;
    display: flex; 
    justify-content: center; 
    align-items: center;
    position: relative;
}

.asset_group {
    color: #fff;
    opacity: 0.8;
    padding: 4px 8px;
    border-radius: 4px;
    margin-right: 4px;
    font-size: 11px;
    width: 70px;
    display:inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}
.asset_group_more{
    color: #aaa;
    font-size: 12px;
    height: 20px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(1) {
    width: 5%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(2) {
    padding: 0px;
    width: 130px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(3) {
    width: 34%;
}
/* .data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(1) {
    width: 10px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(2) {
    width: 1%;
    padding: 0px;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(3) {
    width: 32%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(4) {
    width: 12%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(5) {
    width: 2%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(6) {
    width: 10%;
}
.data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(7) {
    width: 10%;
} */

.overlay_wrap{
    width: 100%;
    height: 100%;
    background: rgba(255, 74, 74, 0.4);
}
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
 
 border-radius: 50%;
  transform: translate(-50%, -50%);
}

.overlay v-icon {
  font-size: 48px;
  color: white;
  cursor: pointer;
}

.socialupload .type_txt{
    font-size: 12px;
    color: #888;
}

.social_title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.socialupload .type_check{
    height: 46px;
    justify-content: center;
}
.social-upload-btn-wrapper {
    position: relative;
    display: inline-flex;
}
.btn-lock-overlay {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    border-radius: 999px;
    border: 1px solid #cbd5f5;
    background: rgba(226, 232, 240, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
}
.nonetype .media_none{
    display: flex;
    justify-content: center;
    align-items: center;
}
.nonetype .media_none img{
    width: 160px;
    justify-content: center;
    align-items: center;
    display: flex;
}.nonetype .media_none .txt{
    color: #888;
}
.stepperheader{
    height: 72px;
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.media_none .upload_title{
    width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.not_connected {
    font-size: 10px;
    color: #F46545;
    background: #F7E3E1;
    padding: 4px 6px 4px 6px;
    border-radius: 4px;
    margin-left: 4px;
}
.connected{
    font-size: 10px;
    color: #49B040;
    background: #E6F7E1;
    padding: 4px 6px 4px 6px;
    border-radius: 4px;
    margin-left: 20px;
}

.notconnecttype{
    display: grid;
    align-content: center;
    justify-content: center;
    height: 200px;
}
.notconnecttype .txt{
    color: #888;
}

@media only screen and (max-width: 600px) {
    .data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(1) {
        width: 100%;
    }
    .data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(2) {
        padding: 16px;
        width: 100%;
    }
    .data-table >>> .v-data-table__wrapper table tbody tr td:nth-child(3) {
        width: 100%;
    }
}
</style>
